"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaTrack = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
class MediaTrack {
    constructor(track) {
        this.track = track;
        this.enabledSubject = new rxjs_1.BehaviorSubject(this.track.enabled);
        this.enabled = this.enabledSubject.asObservable();
        this.startedSubject = new rxjs_1.BehaviorSubject(this.track.readyState === 'live');
        this.started = this.startedSubject.asObservable().pipe((0, operators_1.switchMap)(() => (0, rxjs_1.interval)(25).pipe((0, operators_1.map)(() => this.track.readyState === 'live'), (0, operators_1.distinctUntilChanged)())));
    }
}
exports.MediaTrack = MediaTrack;
//# sourceMappingURL=media_track.js.map